import React from 'react';
import { Box, Container, Typography, Button, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

const BASE_PATH = '/peoplefortech/v2';

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: '#000',
  marginBottom: theme.spacing(2),
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('sm')]: { fontSize: '1.5rem' },
}));

const BookingCtaSectionV2 = () => {
  const { t } = useTranslation();

  return (
    <Box id="calendario-reserva" component="section" sx={{ py: 8, backgroundColor: 'rgba(255,255,255,0.5)', scrollMarginTop: 80 }}>
      <Container>
        <Box sx={{ textAlign: 'center' }}>
          <EventAvailableIcon sx={{ fontSize: 48, color: '#000', mb: 1 }} />
          <SectionTitle variant="h4">{t('v2.booking.titleShort')}</SectionTitle>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 3, mb: 3, px: { xs: 1, sm: 2 } }}>
            {[1, 2, 3].map((i) => (
              <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, flex: { xs: '1 1 100%', sm: '1 1 200px' }, maxWidth: 320 }}>
                <Box sx={{ width: 36, height: 36, borderRadius: '50%', bgcolor: '#000', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1rem', flexShrink: 0 }}>{i}</Box>
                <Box>
                  <Typography variant="subtitle2" fontWeight={700} color="text.primary">{t(`v2.booking.step${i}Title`)}</Typography>
                  <Typography variant="body2" color="text.secondary">{t(`v2.booking.step${i}Desc`)}</Typography>
                </Box>
              </Box>
            ))}
          </Box>
          <Button
            component={Link}
            to={`${BASE_PATH}/reserva`}
            variant="contained"
            size="large"
            sx={{
              backgroundColor: '#000',
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              whiteSpace: 'nowrap',
              '&:hover': { backgroundColor: '#333' },
            }}
          >
            {t('v2.booking.cta')}
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default BookingCtaSectionV2;
